import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useCourseList = (params?: Record<string, any>) => {
  const finalParams = {
    pageNumber: 1,
    pageSize: 100,
    ...(params || {}),
  };

  return useQuery({
    queryKey: ['course-list', finalParams],
    queryFn: async () => {
      const res = await request.get('/course', { params: finalParams });
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useCourseGet = (id?: string) => {
  return useQuery({
    queryKey: ['course-get', id],
    queryFn: async () => {
      if (!id) return null;
      try {
        const res = await request.get(`/course/${id}`);
        const data = res.data?.data?.data || res.data?.data || res.data;
        if (data && (data.id || data.translations || data.title || data.name)) {
          return data;
        }
      } catch (e) {
        // Fallback: search by query param
        try {
          const fallbackRes = await request.get('/course', { params: { id, pageSize: 1, pageNumber: 1 } });
          const list = fallbackRes.data?.data?.data || fallbackRes.data?.data || fallbackRes.data;
          if (Array.isArray(list) && list.length > 0) {
            return list[0];
          }
        } catch {
          return null;
        }
      }
      return null;
    },
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5,
  });
};
